import axios from 'axios';
import { setupInterceptors } from './interceptors';
class AxiosLibrary {
  constructor(config) {
    var _a;
    this.instance = axios.create({
      baseURL: config.baseURL,
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: (_a = config.withCredentials) !== null && _a !== void 0 ? _a : false
    });
    setupInterceptors(this.instance, config.onLogout, config.onError, config.accessTokenCookieKey, config.refreshTokenCookieKey, config.refreshTokenCallback);
  }
  getInstance() {
    return this.instance;
  }
}
export default function createAxiosInstance(config) {
  return new AxiosLibrary(config).getInstance();
}